var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cards"},_vm._l((_vm.cards),function(card){return _c('card',{key:card.id,attrs:{"title":card.title,"image":card.image},nativeOn:{"click":function($event){_vm.handleCardClick(card.title)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }